import React from "react";
import cn from "classnames";
import { Divider } from "antd";
import styles from "./CreateMultipleTotes.module.sass";
import Modal from "../../../components/Modal";
import CustomToast from "../../../components/CustomToast";
import { DELETE_TOTES_BY_CODES, REMOVE_TOTE_ORDERS } from "../../../API/Totes";
import CustomAlert from "../../../components/CustomAlert";

const DeleteSingleTote = ({
  isModalVisible,
  handleModalClose,
  handleSuccess,
  toteMarkedToDelete,
  onDeleteComplete,
  actionType,
  checkedItems,
}) => {
  const showToast = CustomToast();
  const { showAlert } = CustomAlert(); 
  const handleOnDeleteClick = async () => {
    try {
      let response;

      if (actionType === "deleteTote") {
        response = await DELETE_TOTES_BY_CODES([toteMarkedToDelete]);
      } else if (actionType === "removeOrders") {
        const orderIds = Object.keys(checkedItems)
          .filter((id) => checkedItems[id])
          .map(Number)
          .filter((id) => !isNaN(id));

        if (orderIds.length === 0) {
          showAlert(
            "Warning",
            "No orders selected to remove",
            "info",
            "OK",
            "",
            null,
            false,
            true,
            false
          );
          return;
        }
        response = await REMOVE_TOTE_ORDERS(toteMarkedToDelete, {
          order_ids: orderIds,
        });
      }
      if (response && response.message) {
        handleSuccess();
        showToast(response.message, "success");
      } else {
        showToast("Action completed successfully", "success");
      }
      handleModalClose();
      if (onDeleteComplete) {
        onDeleteComplete();
      }
    } catch (error) {
      console.error("Failed to perform action:", error);
      const errorMessage =
        error.response?.data?.message || "Failed to perform action";
      showToast(errorMessage, "error");
    }
  };

  return (
    <>
      <Modal visible={isModalVisible} onClose={handleModalClose}>
        <div className={styles.details}>
          <div className={cn("title-green", styles.title)}>Confirm Delete</div>
          <Divider />
          <div className={styles.roww}>
            <div className={styles.coll}>
              <p className="text-[#6F767E] pt-5">
                Are you sure you want to{" "}
                {actionType === "deleteTote"
                  ? "delete the tote?"
                  : "remove orders from this tote?"}
              </p>

              <div className={cn(styles.btns)}>
                <button
                  type="button"
                  className={cn("button-stroke pl-5 pr-5", styles.button)}
                  onClick={handleModalClose}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className={cn(
                    "button-clear-stroke button-clear-stroke-red button-small",
                    styles.button
                  )}
                  onClick={handleOnDeleteClick}
                >
                  {actionType === "deleteTote" ? "Delete" : "Remove order from tote"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default DeleteSingleTote;
